// Draw text inside the icon. Google's separate label layer lets numbers from
// covered pins show through the pin above them when locations are close together.
export function numberedMapMarker(color, numbers, selected = false) {
  const stops = [...new Set(numbers.filter(number => Number.isSafeInteger(number) && number > 0))].sort((a, b) => a - b)
  const joined = stops.join(",")
  const text = !stops.length ? "?" : stops.length <= 2 && joined.length <= 5 ? joined : `${stops[0]}+`
  return mapPin(color, text, selected, "delivery-map-stop-number")
}

export function depotMapMarker() {
  return mapPin("#343a40", "D", false, "delivery-map-depot")
}

function mapPin(color, text, selected, textClass) {
  const safeColor = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(color) ? color : "#6c757d"
  const fontSize = text.length <= 2 ? 16 : text.length <= 4 ? 12 : 10
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="54" viewBox="0 0 42 54"><path fill="${safeColor}" stroke="${selected ? "#111827" : "#fff"}" stroke-width="${selected ? 4 : 2}" d="M21 3C11 3 3 11 3 21c0 12 18 30 18 30s18-18 18-30C39 11 31 3 21 3Z"/><circle cx="21" cy="21" r="14" fill="#fff"/><text class="${textClass}" x="21" y="21" dy=".35em" text-anchor="middle" fill="#111827" font-family="Arial, sans-serif" font-size="${fontSize}" font-weight="700">${text}</text></svg>`
  return {
    icon: {
      anchor: new google.maps.Point(21, 52),
      scaledSize: new google.maps.Size(42, 54), url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
    },
    label: null
  }
}
